export default __webpack_public_path__ + "static/media/Pumps.da75e671.jpg";